import React from "react";
import { Type } from "discover.medical.react-component-library";
import "./index.css";

export const Title = ({ text, children }) => {
  return (
    <div className="Title">
      <Type className="Title__heading" element="h2" color="gray700">
        {text}
      </Type>
      {children}
    </div>
  );
};

export default Title;
